/**
 * Show preloader while fetching user info
 * Check if user permitted to access route
 */

import React, { useContext, useEffect, useRef, useState } from "react"
import { Navigate } from "react-router-dom"
import PropTypes from "prop-types"
import GlobalState from "contexts/GlobalState"
import { getUserInfo } from "helpers/backend_helper"

const Authmiddleware = props => {
  const [state, setState] = useContext(GlobalState)
  const [preloader, setPreloader] = useState(true)
  const abortRef = useRef(null)

  useEffect(() => {
    abortRef.current = new AbortController()
    if (localStorage.getItem("api_token")) {
      setPreloader(true)
      getUserInfo(abortRef.current)
        .then(data => {
          if (data.username != null) {
            setState(state => ({ ...state, authUser: JSON.stringify(data) }))
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          setPreloader(false)
        })
    } else {
      setPreloader(false)
    }
    return () => abortRef.current.abort()
  }, [])

  if (preloader) {
    return (
      <div id="preloader">
        <div id="status">
          <div className="spinner-chase">
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
          </div>
        </div>
      </div>
    )
  }
  if (state.authUser == null || !localStorage.getItem("api_token")) {
    return (
      <Navigate to={{ pathname: "/logout", state: { from: props.location } }} />
    )
  }

  // User role specific
  if (props.roles != null && props.roles.length > 0) {
    try {
      const user = JSON.parse(state.authUser)
      if (!props.roles.includes(user.role)) {
        return (
          <Navigate
            to={{ pathname: "/main", state: { from: props.location } }}
          />
        )
      }
    } catch (e) {
      console.log(e)
      return (
        <Navigate to={{ pathname: "/main", state: { from: props.location } }} />
      )
    }
  }

  // Keycloak realm roles - ignored by system admins for now
  if (props.realm_role != null && props.realm_role.length > 0) {
    try {
      const user = JSON.parse(state.authUser)
      if (!state.realm_roles?.includes(props.realm_role) && user.role != "system_admin") {
        return (
          <Navigate
            to={{ pathname: "/main", state: { from: props.location } }}
          />
        )
      }
    } catch (e) {
      console.log(e)
      return (
        <Navigate to={{ pathname: "/main", state: { from: props.location } }} />
      )
    }
  }

  // Special permissions
  if (props.permission != null && props.permission.length > 0) {
    try {
      const obj = JSON.parse(state.authUser)
      if (
        obj.role != "system_admin" &&
        !obj.access_permissions?.[props.permission]) {
        return (
          <Navigate
            to={{ pathname: "/main", state: { from: props.location } }}
          />
        )
      }
    } catch (e) {
      console.log(e)
      return (
        <Navigate to={{ pathname: "/main", state: { from: props.location } }} />
      )
    }
  }

  return <React.Fragment>{props.children}</React.Fragment>
}

Authmiddleware.propTypes = {
  children: PropTypes.any,
  roles: PropTypes.array,
  realm_role: PropTypes.string,
  permission: PropTypes.any,
  location: PropTypes.object,
}

export default Authmiddleware